// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"96":"vendors","792":"main"}[chunkId] + "." + {"96":"d61656849dd18e6c88b2","792":"a3e6331a42cd1b2270ed"}[chunkId] + ".css";
};